import * as React from 'react';
import { STATE } from 'app/constants';
import { myCaseDraftsTranslations } from 'app/area/my-case-drafts/constants';
import { containerFactory } from 'app/infrastructure/redux/index';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { scrollToTop } from 'app/infrastructure/platform/routing';
import { CaseDraftsTiles } from 'app/area/my-case-drafts/case-drafts-tiles/case-drafts-tiles';
import { CaseViewModal } from 'app/area/case/components/case-view-modal';
import { CaseViewModalProvider } from 'app/area/case/components/case-view-modal/case-view-modal-context';
import { Outlet, useOutletContext } from 'react-router-dom';
import { Draft } from 'app/area/case/draft';
import { withRouter } from 'app/components/enhancers/with-router';
import { LeaveDraftEdit } from 'app/area/case/draft/action-types';
import { useDispatch } from 'react-redux';
import styles from './my-case-drafts.scss';
import { Case } from 'app/area/case';

const DraftWithRouter = withRouter(Draft);
const CaseWithRouter = withRouter(Case);

export class MyCaseDraftsComponent extends React.Component<any, void> {
  public static statePath: string = STATE.myCaseDrafts;

  public componentDidMount() {
    scrollToTop();
  }

  public render() {
    const { translation } = this.props;
    return (<MainGridContainer className={styles.myCaseDraftsView}>
      <div className={styles.downloadItemsWrapper}>
        <div className="page-heading">
          <h1>{translation.my_case_drafts_header}</h1>
        </div>
        <div className="row">
          <CaseDraftsTiles translation={translation} intl={this.props.intl} />
        </div>
      </div>
      <Outlet context={{ renderCaseViewModal: true }} />
    </MainGridContainer>);
  }
}

const container = containerFactory(MyCaseDraftsComponent, {}, {}, myCaseDraftsTranslations);

export { container as MyCaseDrafts };

export const MyCaseDraftsCaseModalContainer = () => {
  const { renderCaseViewModal } = useOutletContext<{ renderCaseViewModal: boolean }>();
  return (
    renderCaseViewModal && <CaseViewModalProvider>
      <CaseViewModal clearSearchParamsOnClose>
        <Outlet />
      </CaseViewModal>
    </CaseViewModalProvider>
  );
};

export const MyCaseDraftsCaseDraft = () => {
  const dispatch = useDispatch();
  React.useEffect(() => {
    return () => { dispatch(new LeaveDraftEdit() as any); };
  }, []);
  return (
    <DraftWithRouter />
  );
};

export const MyCaseDraftsCaseView = () => (
  <CaseWithRouter />
);
